<template>
  <div class="todaySchedule" :class="customClassName" v-if="list">
    <schedule_match_list
      :currCid="currCid"
      :currSid="currSid"
      :currThemeObj="currThemeObj"
      :data="list"
      :detailPathName="''"
      :chooseState="''"
      :themeClass="'onlyDisplay'"
      :matchModeObj="matchModeObj"
      :viewMode="viewMode"
    />
  </div>
</template>

<script>
// 今日赛程 主题
import cup_base_data_mixin from '@mixins/cup_base_data'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
export default {
  name: 'todaySchedule',
  mixins: [cup_base_data_mixin],
  components: {
    schedule_match_list,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    matchModeObj: {
      // 各个赛事都有赛程，但是也有互相复用的，因此抽离一个共用的赛程视图
      type: [Object, null],
      default: () => ({
        mode: '',
        // any: xxx, 根据不同情况添加不同字段
      }), //['compreSportsMeet', 'worldcup']=['综合性赛事', '足球世界杯']
    },
    viewMode: {
      // 相同页面，控制不同视图的展示
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      list: null,
      // list: [
      //   {
      //     matchTime: '09:30',
      //     matchName: '射箭·女子复合弓个人半决赛',
      //     isChina: true,
      //     isGold: false,
      //     type: 'combat',
      //     matchId: 'ARCWCB----------------SFNL000200--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCWCB----------------------------',
      //     eventName: '女子复合弓个人',
      //     scheduleName: '女子复合弓个人半决赛',
      //     formatDate: '07月31日',
      //     formatTime: '09:30',
      //     startDatetimeUtc: '2023-07-31T09:30:00',
      //     medalist: [],
      //     homeName: '斯特吉尔',
      //     awayName: '周嘉玉',
      //     homeScore: '141',
      //     awayScore: '139',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/USA.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
      //   },
      //   {
      //     matchTime: '09:42',
      //     matchName: '射箭·女子复合弓个人半决赛',
      //     isChina: false,
      //     isGold: false,
      //     type: 'combat',
      //     matchId: 'ARCWCB----------------SFNL000100--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCWCB----------------------------',
      //     eventName: '女子复合弓个人',
      //     scheduleName: '女子复合弓个人半决赛',
      //     formatDate: '07月31日',
      //     formatTime: '09:42',
      //     startDatetimeUtc: '2023-07-31T09:42:00',
      //     medalist: [],
      //     homeName: '曹秀雅',
      //     awayName: '阿夫尼特·考尔',
      //     homeScore: '143',
      //     awayScore: '146',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/IND.png',
      //   },
      //   {
      //     matchTime: '09:54',
      //     matchName: '射箭·女子复合弓个人决赛铜牌赛',
      //     isChina: true,
      //     isGold: false,
      //     type: 'combat',
      //     matchId: 'ARCWCB----------------FNL-000200--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCWCB----------------------------',
      //     eventName: '女子复合弓个人',
      //     scheduleName: '女子复合弓个人决赛铜牌赛',
      //     formatDate: '07月31日',
      //     formatTime: '09:54',
      //     startDatetimeUtc: '2023-07-31T09:54:00',
      //     medalist: [],
      //     homeName: '曹秀雅',
      //     awayName: '周嘉玉',
      //     homeScore: '146',
      //     awayScore: '137',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
      //   },
      //   {
      //     matchTime: '10:06',
      //     matchName: '射箭·女子复合弓个人决赛金牌赛',
      //     isChina: false,
      //     isGold: true,
      //     type: 'combat',
      //     matchId: 'ARCWCB----------------FNL-000100--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCWCB----------------------------',
      //     eventName: '女子复合弓个人',
      //     scheduleName: '女子复合弓个人决赛金牌赛',
      //     formatDate: '07月31日',
      //     formatTime: '10:06',
      //     startDatetimeUtc: '2023-07-31T10:06:00',
      //     medalist: [],
      //     homeName: '阿夫尼特·考尔',
      //     awayName: '斯特吉尔',
      //     homeScore: '144',
      //     awayScore: '144',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/IND.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/USA.png',
      //   },
      //   {
      //     matchTime: '10:28',
      //     matchName: '射箭·男子复合弓个人半决赛',
      //     isChina: false,
      //     isGold: false,
      //     type: 'combat',
      //     matchId: 'ARCMCB----------------SFNL000200--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCMCB----------------------------',
      //     eventName: '男子复合弓个人',
      //     scheduleName: '男子复合弓个人半决赛',
      //     formatDate: '07月31日',
      //     formatTime: '10:28',
      //     startDatetimeUtc: '2023-07-31T10:28:00',
      //     medalist: [],
      //     homeName: '德·克莱克',
      //     awayName: '布勒奥',
      //     homeScore: '139',
      //     awayScore: '137',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/RSA.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/FRA.png',
      //   },
      //   {
      //     matchTime: '10:40',
      //     matchName: '射箭·男子复合弓个人半决赛',
      //     isChina: false,
      //     isGold: false,
      //     type: 'combat',
      //     matchId: 'ARCMCB----------------SFNL000100--',
      //     venueName: '成都现代五项赛事中心马术体育场',
      //     matchStatus: 'FINISHED',
      //     sportsId: 'ARC',
      //     sportsName: '射箭',
      //     eventId: 'ARCMCB----------------------------',
      //     eventName: '男子复合弓个人',
      //     scheduleName: '男子复合弓个人半决赛',
      //     formatDate: '07月31日',
      //     formatTime: '10:40',
      //     startDatetimeUtc: '2023-07-31T10:40:00',
      //     medalist: [],
      //     homeName: '赛尼',
      //     awayName: '比斯拉',
      //     homeScore: '147',
      //     awayScore: '147',
      //     homeLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/IND.png',
      //     awayLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/IND.png',
      //   },
      // ],
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList)
      ) {
        this.list = this.matchMode2MakeMatchList(newVal.data.dataList)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    console.debug('todaySchedule:', this.matchModeObj)
    this.list = this.matchMode2MakeMatchList(this.datas.data.dataList)
  },
  computed: {
    customClassName() {
      let className = ''
      if (['BasketballLeague'].includes(this.matchModeObj.mode)) {
        className = 'fixedHeight'
      }
      return className
    },
  },
  methods: {
    matchMode2MakeMatchList(dataList) {
      let matchList = []
      const dataMode = this.matchModeObj.mode
      if (['compreSportsMeet', 'tennis'].includes(dataMode)) {
        matchList = this.computedMatchList_CSMeet(
          dataList,
          this.datas.sportType
        )
      } else if (['FIFAWorldCup', 'WCQAsianZone'].includes(dataMode)) {
        matchList = this.computedMatchList_worldcup(dataList)
      } else if (dataMode === 'badminton') {
        matchList = this.computedMatchList_badminton(dataList)
      } else if (['FootballLeague', 'BasketballLeague'].includes(dataMode)) {
        matchList = this.computedMatchList_LeagueCBA(dataList)
      }
      return matchList
    },
    formatMatchStatus(matchStatus) {
      let str = ''
      const num = Number(matchStatus)
      if (num === 1) {
        str = 'SCHEDULED'
      } else if (num === 2) {
        str = 'RUNNING'
      } else if (num === 3) {
        str = 'CANCELLED'
      } else if (num === 4) {
        str = 'FINISHED'
      } else {
      }
      return str
    },
    computedMatchList_CSMeet(arr, sportType) {
      // 组装综合性赛事 赛程
      console.debug('computedMatchList_CSMeet:', arr)
      let matchList = []
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          let curIndex = 0
          let newItem = {}

          newItem.matchDate = item.startDatetimeUtc.split('T')[0] //暂时通过这个字段获取日期格式:2024-04-09
          let week = '星期' + this.getWeekCN(newItem.matchDate)
          let dateArr = newItem.matchDate.split('-')
          let weekCN = ''
          if (dateArr.length == 3) {
            weekCN = `${dateArr[1]}月${dateArr[2]}日 ${week}`
          }
          newItem.weekCN = weekCN
          newItem.chooseId = item.scheduleCode
          newItem.isChooseFlag = false
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
          newItem.isChina = item.cn
          newItem.isGold = item.medalFlag === '1'
          newItem.type = item.confrontation
            ? this.sportsTypeArr[0]
            : this.sportsTypeArr[1]
          newItem.matchId = item.scheduleCode
          newItem.venueName = item.venueName
          newItem.locationName = item.locationName
          console.debug('computedMatchList_CSMeet tennis:', sportType)
          if (['tennis'].includes(sportType)) {
            newItem.matchStatus = this.formatMatchStatus(item.scheduleStatus)
          } else {
            newItem.matchStatus = item.scheduleStatus
          }
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.scheduleName = item.scheduleName
          newItem.formatDate = item.formatDate
          newItem.formatTime = item.formatTime
          newItem.channels = item.channels
          newItem.competitorType = item.competitorType
          newItem.competitor1Names = item.competitor1Names
          newItem.competitor2Names = item.competitor2Names
          newItem.scheduleComment = item.scheduleComment
          newItem.medalist = item.medals
            ? item.medals.map((player, index) => {
                return {
                  playerId: index + 1,
                  mcompetitorType: player.mcompetitorType,
                  playerName: player.competitorName,
                  medalType: player.medalType,
                  delegationName: player.organisationName,
                  delegationLogo: player.organisationLogo,
                }
              })
            : []

          if (newItem.type === this.sportsTypeArr[0]) {
            let homeName = '',
              awayName = ''
            homeName = item.competitor1Name ? item.competitor1Name : '待定'
            awayName = item.competitor2Name ? item.competitor2Name : '待定'

            newItem.homeName = homeName
            newItem.awayName = awayName

            newItem.homeScore = item.competitor1Result
            newItem.awayScore = item.competitor2Result
          }
          newItem.homeLogo = item.organisation1Logo
          newItem.awayLogo = item.organisation2Logo

          matchList.push(newItem)
        })
      }
      return matchList
    },
    computedMatchList_worldcup(arr) {
      // 足球世界杯组装赛程
      // 切换展示状态，组装不同的赛程列表数据
      console.debug('computedMatchList_worldcup:', arr)
      let matchList = []
      arr.forEach((item) => {
        let week = '星期' + this.getWeekCN(item.matchDate)
        let dateArr = item.matchDate.split('-')
        let weekCN = ''
        if (dateArr.length == 3) {
          weekCN = `${dateArr[1]}月${dateArr[2]}日 ${week}`
        }
        if (!item.joinPointFlag) {
          item.joinPointFlag = false
        }
        if (
          !item.joinPointFlag &&
          (item.homePoint !== null || item.awayPoint !== null)
        ) {
          item.joinPointFlag = true
          item.homeScore = item.homeScore
          item.homeScore = `${item.homeScore}(${item.homePoint})`
          item.awayScore = item.awayScore
          item.awayScore = `${item.awayScore}(${item.awayPoint})`
        }

        item.chooseId = item.matchId
        item.isChooseFlag = false

        // if (typeItem == item[type]) {
        //   if (!obj.label) {
        //     if (type == 'matchDate') {
        //       // 按日期展示
        //       obj.label = weekCN
        //     } else {
        //       // 按小组展示
        //       obj.label = `${typeItem}组`
        //     }
        //   }

        // }
        item.weekCN = weekCN
        matchList.push(item)
      })
      return matchList
    },
    computedMatchList_badminton(arr) {
      // 羽毛球汤尤杯组装赛程
      // 切换展示状态，组装不同的赛程列表数据
      console.debug('computedMatchList_badminton:', arr)
      // 这个地方是为了给播出单使用，所以需要补一下 组别+赛段【小组赛+A组 | 淘汰赛】
      const matchList =
        arr && arr.length > 0
          ? arr.map((item) => {
              if (!item.chooseId) {
                item.matchStatus = this.formatMatchStatus(
                  item.matchStatus ? item.matchStatus + '' : item.matchStatus
                )
                item.matchDate = item.startDate
                item.matchTime = item.startTime
                item.seriesCode = item.stageCode
                item.seriesName = `${item.eventName}${item.stageName}${
                  item.groupName ? item.groupName : ''
                }`
                item.chooseId = item.matchId
                item.isChooseFlag = false
              }

              let week = '星期' + this.getWeekCN(item.matchDate)
              let dateArr = item.matchDate.split('-')
              let weekCN = ''
              if (dateArr.length == 3) {
                weekCN = `${dateArr[1]}月${dateArr[2]}日 ${week}`
              }
              item.weekCN = weekCN
              return item
            })
          : []
      return matchList
    },
    computedMatchList_LeagueCBA(arr) {
      const matchList =
        arr && arr.length > 0
          ? arr.map((item) => {
              let newItem = item
              newItem.gameDate = newItem.matchDate
              newItem.gameTime = newItem.matchTime
              newItem.chooseId = item.matchId
              newItem.isChooseFlag = false
              return newItem
            })
          : []

      return matchList
    },
  },
}
</script>

<style lang="scss" scoped>
.todaySchedule {
  width: 100%;
  &.fixedHeight {
    padding: 0.347vw 0 0.533vw 0;
    height: 100%;
  }
}
</style>
